/**
 * What makes "Cyber Smart Kids" different, said the way a nine-year-old
 * would want to hear it. Shown on the course page and on checkout, so a child
 * deciding whether to start sees the same four promises either way.
 */
const HIGHLIGHTS = [
  {
    icon: '🎮',
    tone: 'grape',
    kicker: 'Practice-based learning',
    title: 'You learn it by doing it',
    text:
      'Every single lesson hands you something to try — a scam to catch, a role to play, a real ' +
      'case to crack. Not a quiz stuck on the end. Right in the middle of the action.',
  },
  {
    icon: '🕵️',
    tone: 'sky',
    kicker: 'Real-world scenarios',
    title: 'Tricks people really use',
    text:
      'Free skins that are not free. A DM from a "friend" who is not your friend. A link that is ' +
      'one letter wrong. Wi-Fi at the mall. If it happens to kids, you practise it here.',
  },
  {
    icon: '🤖',
    tone: 'mint',
    kicker: 'Future-focused curriculum',
    title: 'The stuff that is coming next',
    text:
      'AI, smart speakers listening in, deepfake videos, VR worlds and the rules of being fair ' +
      'online. Most schools have not got here yet. You will.',
  },
  {
    icon: '🏆',
    tone: 'sun',
    kicker: 'Project-based finale',
    title: 'One big final build',
    text:
      'At the very end you design your own locked-down digital world, using every single skill ' +
      'you picked up along the way. That one is your masterpiece.',
  },
];

export default function CourseHighlights({ heading = 'Why this course is different' }) {
  return (
    <section className="why-band" aria-labelledby="why-heading">
      <div className="why-head">
        <h2 id="why-heading">✨ {heading}</h2>
        <p className="muted">Four things you will never get from a slideshow.</p>
      </div>

      <div className="why-grid">
        {HIGHLIGHTS.map((h) => (
          <article key={h.kicker} className={`why-card t-${h.tone}`}>
            <span className="why-icon" aria-hidden="true">{h.icon}</span>
            <span className="why-kicker">{h.kicker}</span>
            <h3>{h.title}</h3>
            <p>{h.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
